export default __webpack_public_path__ + "static/media/Icon feather-search.add2d5a0.svg";